var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.775,
    height: 25.42,
    viewBox: "0 0 31.775 25.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.186,19.888H30.6V8.766A4.766,4.766,0,0,0,25.831,4H9.944A4.766,4.766,0,0,0,5.178,8.766V19.888H3.589A1.589,1.589,0,0,0,2,21.476v3.178A4.766,4.766,0,0,0,6.766,29.42H29.009a4.766,4.766,0,0,0,4.766-4.766V21.476A1.589,1.589,0,0,0,32.186,19.888ZM8.355,8.766A1.589,1.589,0,0,1,9.944,7.178H25.831A1.589,1.589,0,0,1,27.42,8.766V19.888H8.355ZM30.6,24.654a1.589,1.589,0,0,1-1.589,1.589H6.766a1.589,1.589,0,0,1-1.589-1.589V23.065H30.6Z",
    transform: "translate(-2 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.66155d97eeadf793452081f04718a246.svg";
export { ForwardRef as ReactComponent };